import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
export function Testimonials() {
  return <section className="bg-mist px-4 py-20 sm:py-28" data-id="element-308" data-mp="3fzntrlbxjb1d">
      <div className="mx-auto max-w-6xl" data-id="element-309" data-mp="3fy2ytulpdq2z">
        <div className="text-center" data-id="element-310" data-mp="3b0kn5wgawwra">
          <div className="flex justify-center gap-1 text-gold" aria-hidden="true" data-id="element-311" data-mp="3azjefymrcmcq">
            {Array.from({
            length: 5
          }).map((_, i) => <StarIcon key={i} size={18} fill="currentColor" data-id="element-312" data-mp="31zd3okig20h9" data-mpi={i} />)}
          </div>
          <h2 className="mt-4 text-3xl font-semibold text-ink sm:text-4xl" data-id="element-313" data-mp="2x0jlies7plar">
            What Salsa & Bachata instructors are{' '}
            <span className="italic text-burgundy" data-id="element-314" data-mp="2s2rtzlvhc173">saying</span>
          </h2>
        </div>
        <div className="mt-12 grid gap-6 md:grid-cols-3" data-id="element-315" data-mp="v8dljm0necce">
          {testimonials.map((item, index) => <motion.figure key={item.name} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex h-full flex-col rounded-xl border border-gold/20 bg-white p-6 shadow-soft sm:p-7" data-id="element-316" data-mp="qbn7134hrot3" data-mpi={index}>
              <div className="flex gap-0.5 text-gold" aria-label="5 out of 5 stars" data-id="element-317" data-mp="zw68onx3vnfl">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} size={14} fill="currentColor" aria-hidden="true" data-id="element-318" data-mp="14xlp22oc95rn" data-mpi={i} />)}
              </div>
              <blockquote className="mt-4 pb-6 font-display text-lg italic leading-8 text-ink" data-id="element-319" data-mp="v5g1d554dai9">
                “{item.quote}”
              </blockquote>
              <figcaption className="mt-auto flex items-center gap-3 border-t border-gold/20 pt-5" data-id="element-320" data-mp="1itqxxw3s8o0q">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-wine text-sm font-semibold text-cream" data-id="element-321" data-mp="1nnlfasvx0qwn">
                  {item.name.split(' ').map(part => part[0]).join('')}
                </span>
                <span className="text-sm leading-5" data-id="element-322" data-mp="1ofrh2wl64or2">
                  <span className="block font-semibold text-ink" data-id="element-323" data-mp="1jir9gh8o7dxu">
                    {item.name}
                  </span>
                  <span className="block text-burgundy" data-id="element-324" data-mp="1ek6fv0nxbsid">
                    {item.role} · {item.location}
                  </span>
                </span>
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}